import { render, staticRenderFns } from "./DataFileUpload.vue?vue&type=template&id=16cdff7b&"
import script from "./DataFileUpload.vue?vue&type=script&lang=ts&"
export * from "./DataFileUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports